import * as Constants from '../../constants';

export const cv = {
    get links(): ReturnType<typeof Constants.getCVLinks> {
        return Constants.getCVLinks(this);
    },
    path: 'cv',
    PDFTitle: 'Download PDF',
    PDFPrefix: Constants.CV_PDFPrefix,
    general: `I am an accountant with over 10 years of experience in accounting and taxation, gained in both Poland and Belarus. 
    Currently, I work at an accounting office in Poland, where I actively support the accounting processes for clients – including posting documents,
    handling domestic and international settlements, cost accounting, and preparing financial statements.
    My previous experience in the tax administration enables me to better understand tax regulations and apply them effectively in practice.
    I continuously develop my professional skills through courses and training organized by the Association of Accountants in Poland.
    I am a reliable, independent, and committed professional, ready for further development and new professional challenges.`,
    consent: `I consent to the processing of my personal data for the purpose of recruiting for the position I am applying for`,
    skills: {
        title: 'SKILLS',
        all: [
            `knowledge of Enova365, Saldeo, Optima, Kamsoft`,
            'knowledge of MS Office',
            'excellent work organization',
            'scrupulity and responsibility',
            'communication skills',
            'ability to work in a team',
        ],
    },
    languages: {
        title: 'LANGUAGE SKILLS',
        all: [
            { language: 'Polish language:', level: Constants.levelPL },
            { language: 'English language:', level: Constants.levelENG },
            { language: 'Russian language:', level: 'native' },
        ],
    },
    university: {
        title: 'EDUCATION',
        all: [
            {
                years: `2004-2009`,
                nameUniversity: `Francisk Skorina Gomel State University`,
                url: `https://www.gsu.by/`,
                speciality: `economics`,
                specialityTitle: 'speciality',
            },
        ],
    },
    courses: {
        title: 'ADDITIONAL COURSES',
        all: [
            {
                years: `2025 - 2026`,
                nameUniversity: `Association of Accountants of Poland`,
                url: `https://skwp.pl/`,
                speciality: `Chief Accountant`,
                specialityTitle: 'speciality',
                certPath: Constants.certPL_3,
            },
            {
                years: `2024 - 2025`,
                nameUniversity: `Association of Accountants of Poland`,
                url: `https://skwp.pl/`,
                speciality: `Senior Accountant`,
                specialityTitle: 'speciality',
                certPath: Constants.certPL_2,
            },
            {
                years: `2023-2024`,
                nameUniversity: `Association of Accountants of Poland`,
                url: `https://skwp.pl/`,
                speciality: `Accountant`,
                specialityTitle: 'speciality',
                certPath: Constants.certPL_1,
            },
            {
                years: `2024 - 2026`,
                nameUniversity: `Cosinus Post-seconary School`,
                url: `https://www.cosinus.pl/`,
                speciality: `Administration`,
                specialityTitle: 'speciality',
                certPath: Constants.certPL_0,
            },
        ],
    },
    experience: {
        title: 'EXPERIENCE',
        all: [
            {
                year: `January 2026 - Present`,
                place: `Ergotax sp. z o.o., accounting office, Poland`,
                profession: `Accountant`,
                experiences: [
                    `Handling the full accounting cycle - from verification and posting of documents to reconciliation of accounts and preparation of data for month-end closing.`,
                    `Posting documents related to revenues, costs, fixed assets, import of services and intra-Community acquisitions.`,
                    `Checking the correctness and completeness of accounting documentation.`,
                    `Reconciling accounting accounts and analysing balances and accounting entries.`,
                    `Preparing data and statements for tax settlements and month-end closing.`,
                    `Preparing reports for GUS (Central Statistical Office).`,
                ],
            },
            {
                year: `October 2024 - March 2026`,
                place: `Jadmar sp. z o.o., accounting office, Poland`,
                profession: `Accountant`,
                experiences: [
                    `Posting accounting documents in full accounting.`,
                    `Posting bank statements and cash reports.`,
                    `Recording costs, revenues and accruals.`,
                    `Reconciling settlements with contractors.`,
                    `Performing month-end closing tasks.`,
                    `Calculating VAT and CIT taxes.`,
                    `Preparing VAT tax declarations.`,
                    `Preparing reports for GUS (Central Statistical Office).`,
                ],
            },
            {
                year: `2017 - 2021; 2023 - 2024`,
                place: `FotoCeramika sp. z o.o., Belarus`,
                profession: `Independent Accountant`,
                experiences: [
                    `Maintaining accounting records, posting revenues, costs, bank and cash operations.`,
                    `Controlling settlements with suppliers and customers.`,
                    `Processing payments and managing the organization's current accounts.`,
                    `Preparing financial statements, GUS reports and tax settlements.`,
                    `Collaborating with external institutions (tax office, social security office, others).`,
                ],
            },
            {
                year: `2009 - 2017; 2021 - 2022`,
                place: `Tax office, department of control over legal entities, Belarus`,
                profession: `Tax inspector`,
                experiences: [
                    `Conducting tax audits of legal entities.`,
                    `Verifying the correctness of accounting documentation and tax settlements.`,
                    `Controlling VAT, CIT, PIT settlements and tax-deductible costs.`,
                ],
            },
        ],
    },
    interests: {
        title: 'INTERESTS',
        all: [`Gym`, `reading`, `healthy lifestyle`, `development of personal and professional qualities`],
    },
};
